import { render, staticRenderFns } from "./DurationPills.vue?vue&type=template&id=19c26eee&scoped=true"
import script from "./DurationPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./DurationPills.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DurationPills.vue?vue&type=style&index=0&id=19c26eee&prod&lang=scss&scoped=true"
import style1 from "./DurationPills.vue?vue&type=style&index=1&id=19c26eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c26eee",
  null
  
)

export default component.exports